<!-- 
 01-01-2025
 Copyright (c) 2016 Aruba. All Rights Reserved.  
 -->
<div class="modal-header">
  <div *ngIf="withConfirmExtraMessage && status === statusList.SUCCESS && paireOtp === false">
    <div
      class="modal-title h4"
      [innerHTML]="inputTranslateKey + '.' + status.toLowerCase() + '.title' | translate"
    ></div>
  </div>
  <div
    *ngIf="
      (status !== statusList.SUCCESS || !withConfirmExtraMessage) &&
      paireOtp === false &&
      typeTitle !== 'postpone' &&
      typeTitle !== 'new' &&
      typeTitle !== 'generate'
    "
  >
    <div class="modal-title h4">{{ inputTranslateKey + '.title' | translate }}</div>
  </div>
  <div *ngIf="paireOtp === true">
    <div class="modal-title h4">{{ inputTranslateKey + '.titleOtp' | translate }}</div>
  </div>
  <div *ngIf="typeTitle === 'postpone'">
    <div class="modal-title h4">{{ inputTranslateKey + '.titlePostpone' | translate }}</div>
  </div>
  <div *ngIf="typeTitle === 'new'">
    <div class="modal-title h4">{{ inputTranslateKey + '.titleCreate' | translate }}</div>
  </div>
  <div *ngIf="typeTitle === 'generate'">
    <div class="modal-title h4">{{ inputTranslateKey + '.titleGenerate' | translate }}</div>
  </div>
  <button aria-label="Close" data-dismiss="modal" class="close" type="button" (click)="closeTwoFactorAppFlow()">
    <span aria-hidden="true">{{ 'main.charX' | translate }}</span>
  </button>
</div>
<ng-container *ngIf="status === statusList.PENDING">
  <div class="modal-body">
    <div class="row">
      <div
        class="col-md-12 font-16 text-center"
        [innerHTML]="inputTranslateKey + '.pending.message1' | translate"
      ></div>

      <div class="col-md-12 text-center my-2">
        <video *ngIf="videoViewSafary" width="326" height="320" autoplay playsInline webkit-playsinline loop muted 
        id="video1">
          <source [src]="_videoStringUrl | safe : 'url'" type="video/mp4" />
        </video>
        <img *ngIf="imageViewSafary" id="imgDispo" alt="" width="266" height="240" 
        [src]="_imgStringUrl | safe : 'url'" />
      </div>
      <div
        class="col-md-12 mb-4 font-16 text-center"
        [innerHTML]="inputTranslateKey + '.pending.message2' | translate"
      ></div>
      <div class="col-md-12 mb-4 text-center">
        <button
          type="button"
          class="position-relative disablea font-16 fw-bold"
          (click)="selectedRetryMethod(CHANNELS.DEVICE_OTP)"
          [innerHTML]="inputTranslateKey + '.expired.btnGenerateCode' | translate"
        ></button>
      </div>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="status === statusList.EXPIRED">
  <div class="modal-body text-center">
    <div class="col-md-12 mb-4">
      <p class="mb-2 font-18"><strong [innerHTML]="inputTranslateKey + '.expired.heading' | translate"> </strong></p>
      <span
        class="font-14"
        [innerHTML]="
          inputTranslateKey + '.expired.message1' | translate : { device: (currentDevice$ | async)?.deviceName }
        "
      ></span>
    </div>
    <div class="col-md-12 mb-4">
      <button
        type="button"
        class="btn btn-lg btn-primary px-5 col-md-6"
        (click)="selectedRetryMethod(CHANNELS.PUSH_NOTIFICATION)"
        [innerHTML]="inputTranslateKey + '.expired.btnRetry' | translate"
      ></button>
    </div>
    <div class="col-md-12 mb-4 border-bottom-no-device"></div>
    <div class="col-md-12 mb-4">
      <p class="mb-0 font-16" [innerHTML]="inputTranslateKey + '.expired.message2' | translate"></p>
    </div>
    <hr />
    <div class="col-md-12 mb-4">
      <button
        type="button"
        class="btn btn-lg btn-outline-primary col-md-6 font-lato fw-bold"
        (click)="selectedRetryMethod(CHANNELS.DEVICE_OTP)"
        [innerHTML]="inputTranslateKey + '.expired.btnGenerateCode' | translate"
      ></button>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="status === statusList.GEN_CODE_OTP">
  <ap-modal-verification-code-form
    #verifyFormComponent
    [events]="eventsFocus.asObservable()"
    [descriptionText]="
      inputTranslateKey + '.gencodeOTP.description' | translate : { device: (currentDevice$ | async)?.deviceName }
    "
    [verifyCodeLabelText]="inputTranslateKey + '.gencodeOTP.label' | translate"
    [disableRequestNewCode]="true"
    [disableModifica]="true"
    [submitButtonText]="inputTranslateKey + '.gencodeOTP.btnVerify' | translate"
    [backButtonTxt]="inputTranslateKey + '.gencodeOTP.btnDismiss' | translate"
    [descLinkSmsText]="inputTranslateKey + '.gencodeOTP.descLinkSms' | translate"
    [linkSmsText]="inputTranslateKey + '.gencodeOTP.linkSms' | translate"
    (onVerificationCodeSubmitted)="startEndAuthRequest($event)"
    (onGoBackClicked)="status = statusList.EXPIRED"
    (onSelectedRetryMethodClicked)="selectedRetryMethod(CHANNELS.SMS)"
  >
  </ap-modal-verification-code-form>
</ng-container>
<ng-container *ngIf="status === statusList.GEN_CODE_SMS">
  <ap-modal-verification-code-form
    #verifyFormComponent
    [events]="eventsFocus.asObservable()"
    [descriptionText]="inputTranslateKey + '.gencodeSMS.description' | translate : { mobile: mobileContact?.value }"
    [verifyCodeLabelText]="inputTranslateKey + '.gencodeSMS.label' | translate"
    [requestNewCodeText]="inputTranslateKey + '.gencodeSMS.sendBackLabel' | translate"
    [requestNewCodeLinkText]="inputTranslateKey + '.gencodeSMS.sendBackLink' | translate"
    [submitButtonText]="inputTranslateKey + '.gencodeSMS.btnVerify' | translate"
    [backButtonTxt]="inputTranslateKey + '.gencodeSMS.btnDismiss' | translate"
    [disableModifica]="!noDocaPosteView"
    [modificaloButtonTxt]="noDocaPosteView ? (inputTranslateKey + '.gencodeSMS.btnModifica' | translate) : ''"
    (onNewCodeRequestClicked)="selectedRetryMethod(CHANNELS.SMS)"
    (onVerificationCodeSubmitted)="startEndAuthRequest($event)"
    (onGoBackClicked)="noDocaPosteView ? (status = statusList.EXPIRED) : activeModal.dismiss('closed')"
  >
  </ap-modal-verification-code-form>
</ng-container>
<ng-container *ngIf="status === statusList.FAILURE || status === statusList.SUCCESS">
  <ap-modal-confirm-result
    [resultText]="
      !withConfirmExtraMessage || status === statusList.FAILURE
        ? (inputTranslateKey + '.' + status.toLowerCase() + '.message' | translate)
        : ''
    "
    [extraResultText2]="
      withConfirmExtraMessage && status === statusList.SUCCESS
        ? (inputTranslateKey + '.' + status.toLowerCase() + '.extraMessage2' | translate)
        : ''
    "
    [extraErrorMessageText]="status === statusList.FAILURE ? extraErrorMessage : ''"
    [alertText]="
      withConfirmExtraMessage && status === statusList.SUCCESS
        ? (inputTranslateKey + '.' + status.toLowerCase() + '.alertCrypt' | translate)
        : ''
    "
    [btnText]="
      !withConfirmExtraMessage ? (inputTranslateKey + '.' + status.toLowerCase() + '.btnClose' | translate) : ''
    "
    [btnText2]="
      withConfirmExtraMessage ? (inputTranslateKey + '.' + status.toLowerCase() + '.btnClose2' | translate) : ''
    "
    [isSuccess]="status === statusList.SUCCESS ? true : false"
    (onSubmit)="closeTwoFactorAppFlow()"
  >
  </ap-modal-confirm-result>
</ng-container>
